import { Plus, MapPin, Navigation, CheckCircle2 } from "lucide-react";
import { AppChrome } from "./DashboardMockup";

const pins = [
    { x: "16%", y: "32%", label: "A", done: true },
    { x: "40%", y: "22%", label: "B", done: true },
    { x: "64%", y: "40%", label: "C", done: true },
    { x: "80%", y: "60%", label: "D", done: false },
    { x: "54%", y: "72%", label: "E", done: false },
];

const checkins = [
    { name: "Rahul Sharma", detail: "Checked in · Skyline Group, Whitefield", time: "11:42 AM", pct: 90 },
    { name: "Priya Nair", detail: "Visit done · Northwind Realty, HSR", time: "11:05 AM", pct: 88 },
    { name: "Arun Thomas", detail: "En route · Meridian Estates", time: "10:50 AM", pct: 76 },
];

const FieldSalesScreen = () => (
    <div>
        <AppChrome active="Field Sales" />
        <div className="bg-[#F7F9FA] p-3.5 sm:p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                    <p className="font-display text-[15px] font-extrabold text-[#111827]">Field Sales</p>
                    <p className="text-[10px] text-[#64748B]">Tuesday, 21 Jul · Bengaluru South territory</p>
                </div>
                <div className="flex items-center gap-1.5">
                    <span className="hidden items-center gap-1 rounded-lg border border-[#E5E7EB] bg-white px-2 py-1 text-[9px] font-semibold text-[#475569] sm:flex">
                        <Navigation className="h-2.5 w-2.5" /> Optimize Route
                    </span>
                    <span className="flex items-center gap-1 rounded-lg bg-[#16A34A] px-2 py-1 text-[9px] font-bold text-white">
                        <Plus className="h-2.5 w-2.5" /> Plan Visits
                    </span>
                </div>
            </div>

            <div className="mt-2.5 grid gap-2 lg:grid-cols-5">
                {/* Map */}
                <div className="relative overflow-hidden rounded-xl border border-[#EDF0F3] bg-white shadow-sm lg:col-span-3">
                    <div className="relative h-[190px] bg-[#F3F7F4]">
                        <svg className="absolute inset-0 h-full w-full" aria-hidden="true">
                            <defs>
                                <pattern id="tourmap" width="40" height="40" patternUnits="userSpaceOnUse">
                                    <path d="M40 0H0V40" fill="none" stroke="#E2E8F0" strokeWidth="1" />
                                </pattern>
                            </defs>
                            <rect width="100%" height="100%" fill="url(#tourmap)" />
                            <path
                                d="M 60 60 Q 150 20 200 50 T 330 90 Q 390 130 340 160"
                                fill="none" stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round"
                                strokeDasharray="6 6" className="animate-dash-flow" opacity="0.7"
                            />
                        </svg>
                        {pins.map((p) => (
                            <span
                                key={p.label}
                                className={`absolute flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white text-[8px] font-bold text-white shadow-md ${p.done ? "bg-[#16A34A]" : "bg-[#94A3B8]"}`}
                                style={{ left: p.x, top: p.y }}
                            >
                                {p.label}
                            </span>
                        ))}
                        <span className="absolute bottom-2 left-2 rounded-full bg-white/90 px-2 py-1 text-[8px] font-semibold text-[#475569] shadow-sm">
                            Route · 24.6 km · 8 stops
                        </span>
                    </div>
                </div>

                {/* Plan + team */}
                <div className="grid gap-2 lg:col-span-2">
                    <div className="flex items-center justify-between rounded-xl border border-[#EDF0F3] bg-white p-3 shadow-sm">
                        <div>
                            <p className="text-[8px] font-bold uppercase tracking-[0.1em] text-[#94A3B8]">Today's Plan</p>
                            <p className="mt-1 font-display text-[17px] font-extrabold leading-none text-[#111827]">6<span className="text-[#94A3B8]">/8</span></p>
                            <p className="mt-0.5 text-[8px] font-medium text-[#64748B]">visits completed</p>
                        </div>
                        <div className="relative h-11 w-11">
                            <svg viewBox="0 0 56 56" className="h-full w-full -rotate-90">
                                <circle cx="28" cy="28" r="24" fill="none" stroke="#F0FDF4" strokeWidth="8" />
                                <circle cx="28" cy="28" r="24" fill="none" stroke="#16A34A" strokeWidth="8" strokeLinecap="round" strokeDasharray="150.8" strokeDashoffset="37.7" />
                            </svg>
                        </div>
                    </div>
                    <div className="grid gap-1.5">
                        {checkins.map((c) => (
                            <div key={c.name} className="flex items-center gap-2 rounded-xl border border-[#EDF0F3] bg-white px-2.5 py-2 shadow-sm">
                                <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${c.pct > 80 ? "bg-[#F0FDF4]" : "bg-[#F8FAFC]"}`}>
                                    {c.detail.startsWith("Checked") || c.detail.startsWith("Visit")
                                        ? <CheckCircle2 className="h-3 w-3 text-[#16A34A]" />
                                        : <MapPin className="h-3 w-3 text-[#F59E0B]" />}
                                </span>
                                <div className="min-w-0 flex-1">
                                    <p className="truncate text-[9px] font-semibold text-[#111827]">{c.name} · {c.pct}%</p>
                                    <p className="truncate text-[8px] text-[#94A3B8]">{c.detail}</p>
                                </div>
                                <span className="shrink-0 text-[7px] font-bold text-[#94A3B8]">{c.time}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default FieldSalesScreen;
